/**
 * Point d'entrée unique - Adaptive Images System
 * Expose l'API publique et initialise automatiquement le système
 */

import { AdaptiveImages } from './core/adaptive-api.mjs';

// Expose l'API publique globalement
window.AdaptiveImages = AdaptiveImages;

// Initialisation automatique au chargement du DOM
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', AdaptiveImages.init);
} else {
    // DOM déjà chargé
    AdaptiveImages.init();
}
